export const E_REQUIRE_CAMERA_PERMISSION = 'E_REQUIRE_CAMERA_PERMISSION';
